rebru.toastr = function() {

    var defaultoptions = {
        "closeButton": true,
        "debug": false,
        "newestOnTop": true,
        "progressBar": true,
        "positionClass": "toast-top-right",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": "300",
        "hideDuration": "1000",
        "timeOut": "2500",
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    }

    return {
        options: defaultoptions,
        publish: function(type, meldung, titel, options) {
            var publishOptions = $.extend(rebru.toastr.options, options);
            switch(type)
            {
                case 'success':
                    toastr.success(meldung, titel, publishOptions);
                    break;

                case 'warning':
                    toastr.warning(meldung,titel, publishOptions);
                    break;

                case 'error':
                    toastr.error(meldung,titel, publishOptions);
                    break;

                case 'info':
                    toastr.info(meldung,titel, publishOptions);
                    break;

                default: toastr.info(meldung,titel,publishOptions);
            }

            $('[data-toggle="tooltip"]').tooltip('dispose');
        }
    }
}();